import React from 'react';
import PropTypes from 'prop-types';

export default function RadioGroup({
	children, errorMessage, input, label, meta
}) {
	return (
		<div className="radio-group">
			<div className="radio-group-label">
				{label}
			</div>
			{React.Children.map(children, (child) => (
				React.cloneElement(child, {
					name: input.name,
					checked: input.value === child.props.value,
					onChange: input.onChange,
				})
			))}
			{meta.touched && meta.error &&
				<div className="input-error">
					{errorMessage || meta.error}
				</div>
			}
		</div>
	);
}

RadioGroup.propTypes = {
	children: PropTypes.node,
	errorMessage: PropTypes.string,
	input: PropTypes.object.isRequired,
	label: PropTypes.string,
	meta: PropTypes.shape({
		touched: PropTypes.bool,
		error: PropTypes.string
	}),
};
